<div class="cancel-modal">
    <div class="cancel-modal__header">
        <div class="header-copy">
            <div class="title-row">
                <mat-icon class="warning-icon">report_gmailerrorred</mat-icon>
                <h2>Reservierung stornieren</h2>
            </div>

            <p>Möchten Sie diese Reservierung wirklich stornieren?</p>
        </div>

        <button type="button" class="close-button" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <section class="reservation-card">
        <div class="reservation-card__top">
            <div class="guest-copy">
                <div class="guest-name">{{ data.reservation.guestName }}</div>
                <div class="guest-phone">{{ data.reservation.phone }}</div>
            </div>

            <span class="status-pill">
                {{ data.reservation.status }}
            </span>
        </div>

        <div class="reservation-card__divider"></div>

        <div class="info-grid">
            <div class="info-item">
                <div class="info-label">Show</div>
                <div class="info-value">{{ data.reservation.showTitle }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">Datum</div>
                <div class="info-value">{{ data.reservation.showDateLabelLong }}</div>
            </div>

            <div class="info-item">
                <div class="info-label">Zeitblock</div>
                <div class="info-value">{{ data.reservation.block }} ({{ data.reservation.blockTime }})</div>
            </div>

            <div class="info-item">
                <div class="info-label">Tisch / Personen</div>
                <div class="info-value">{{ data.reservation.table }} · {{ data.reservation.persons }} Pers.</div>
            </div>
        </div>
    </section>

    <section class="order-section" *ngIf="hasOrderItems">
        <div class="order-header">
            <div class="section-title">BESTELLUNG</div>

            <span class="source-pill">
                <mat-icon>
                    {{
                    data.reservation.source === 'Web'
                    ? 'public'
                    : data.reservation.source === 'Kasse'
                    ? 'desktop_windows'
                    : 'admin_panel_settings'
                    }}
                </mat-icon>
                <span>{{ data.reservation.orderLabel }}</span>
            </span>
        </div>

        <div class="order-items">
            <div class="order-row" *ngFor="let item of data.reservation.orderItems">
                <div class="order-name">{{ item.quantity }}× {{ item.name }}</div>
                <div class="order-price">{{ item.price }}</div>
            </div>
        </div>

        <div class="order-total">
            <span>Gesamt</span>
            <span>{{ data.reservation.amount }}</span>
        </div>
    </section>

    <div class="action-row">
        <button type="button" class="secondary-button" (click)="close()">
            Abbrechen
        </button>

        <button type="button" class="danger-button" (click)="confirm()">
            Reservierung stornieren
        </button>
    </div>
</div>